export default __webpack_public_path__ + "static/banner-insurance-credit-cards-b7260c2615e95378d970521672de7bab.jpg";